import { render } from "./MenuDashboard.vue?vue&type=template&id=2bf7f122"
import script from "./MenuDashboard.vue?vue&type=script&lang=js"
export * from "./MenuDashboard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\DELL\\source\\repos\\project0810frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])